<template>
  <div
    class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-18 mb-12"
  >
    <div class="px-4">
      <h1
        class="text-center mx-auto max-w-6xl text-3xl lg:text-5xl font-medium mb-10"
        v-html="dataLocales.data.title"
      ></h1>
      <p class="text-lg md:text-xl text-center">
        {{ dataLocales.data.description }}
      </p>
      <div class="mt-24 lg:gap-x-12 gap-y-12 grid grid-cols-12">
        <div
          class="col-span-12 lg:col-span-6 h-full flex items-center justify-center lg:flex-col xs:flex-row flex-col gap-12"
        >
          <div
            class="px-8 py-9 rounded-md drop-shadow-md bg-white w-full mx-auto max-w-md"
          >
            <div
              class="mb-10 w-20 h-20 mx-auto drop-shadow-md rounded-full bg-gradient-to-r from-green-500 via-green-600 to-success flex items-center justify-center -mt-16"
            >
              <MailIcon size="32" class="text-white" />
            </div>
            <div class="text-center">
              <h3 class="text-xl mb-6">Email</h3>
              <a
                href="mailto:info@qrgateway.com"
                class="text-lg hover:text-success"
                >info@qrgateway.com</a
              >
            </div>
          </div>
          <div
            class="px-8 py-9 rounded-md drop-shadow-md bg-white w-full mx-auto max-w-md"
          >
            <div
              class="mb-10 w-20 h-20 mx-auto drop-shadow-md rounded-full bg-gradient-to-r from-green-500 via-green-600 to-success flex items-center justify-center -mt-16"
            >
              <DeviceLandlinePhoneIcon size="32" class="text-white" />
            </div>
            <div class="text-center">
              <h3 class="text-xl mb-6">{{ dataLocales.data.number_phone }}</h3>
              <a href="tel:+1 669-200-5434" class="text-lg hover:text-success"
                >+1 669-200-5434</a
              >
            </div>
          </div>
        </div>
        <div class="col-span-12 lg:col-span-6 sm:px-10 px-4">
          <h2
            class="text-2xl sm:text-3xl"
            v-html="dataLocales.data.title2"
          ></h2>
          <form @submit.prevent="submitContact()" class="mt-12 text-base">
            <div class="mb-5 relative">
              <label for="" class="absolute pl-4 leading-[60px]">{{
                dataLocales.data.fullname
              }}</label>
              <input
                required
                type="text"
                class="h-[60px] w-full rounded-md bg-gray-100 focus:outline-2 focus:outline-success focus:bg-white pl-2 focus:pl-28 transition-all ease-in-out"
                :class="{ 'pl-28': form.name }"
                v-model="form.name"
              />
            </div>
            <div class="mb-5 relative">
              <label for="" class="absolute pl-4 leading-[60px]">Email</label>
              <input
                required
                type="email"
                class="h-[60px] w-full rounded-md bg-gray-100 focus:outline-2 focus:outline-success focus:bg-white pl-2 focus:pl-28 transition-all ease-in-out"
                :class="{ 'pl-28': form.email }"
                v-model="form.email"
              />
            </div>
            <div class="mb-5 relative">
              <label for="" class="absolute pl-4 leading-[60px]"
                >{{ dataLocales.data.phone }}
              </label>
              <input
                type="text"
                class="h-[60px] w-full rounded-md bg-gray-100 focus:outline-2 focus:outline-success focus:bg-white pl-2 focus:pl-28 transition-all ease-in-out"
                :class="{ 'pl-28': form.phone }"
                v-model="form.phone"
              />
            </div>
            <div class="mb-5 relative">
              <label for="" class="absolute pl-4 leading-[60px]">{{
                dataLocales.data.subject
              }}</label>
              <input
                type="text"
                class="h-[60px] w-full rounded-md bg-gray-100 focus:outline-2 focus:outline-success focus:bg-white pl-2 focus:pl-28 transition-all ease-in-out"
                :class="{ 'pl-28': form.subject }"
                v-model="form.subject"
              />
            </div>
            <div class="mb-5 relative">
              <textarea
                required
                v-model="form.message"
                rows="5"
                :placeholder="dataLocales.data.message"
                class="p-4 bg-gray-100 accent-black rounded-md focus:outline-2 focus:outline-success focus:bg-white w-full"
              ></textarea>
            </div>
            <div
              v-if="submitted"
              class="sm:flex-row flex-col flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 rounded-2xl py-6 sm:py-4 sm:px-6 p-3 my-8 bg-success-light"
            >
              <div class="flex-grow flex gap-1">
                <CircleCheckFilledIcon class="text-success" />
                <p class="font-medium sm:text-left sm:line-clamp-1">
                  {{ dataLocales.data.thank }}
                </p>
              </div>
              <a
                target="_blank"
                :href="runtimeConfig.public.app_user_url + '/sign-up'"
                class="flex-shrink-0 w-fit px-6 py-2 text font-medium text-md shadow bg-white rounded-lg hover:shadow-md"
              >
                {{ $t("start_for_free") }}
              </a>
            </div>
            <button
              type="submit"
              :disabled="loading"
              class="flex items-center gap-2 h-10 xs:h-[50px] px-8 rounded-md bg-success text-white drop-shadow-md hover:drop-shadow-xl mt-12"
            >
              <IconsLoadingDecorator class="w-4" v-if="loading" />
              {{ dataLocales.data.send }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { CircleCheckFilledIcon } from "vue-tabler-icons";
import { useNotification } from "@kyvg/vue3-notification";
import { MailIcon, DeviceLandlinePhoneIcon } from "vue-tabler-icons";
import DataLocale from "~~/config/interface/DataLocale";
import moment from "moment";
const { notify } = useNotification();
const runtimeConfig = useRuntimeConfig();
const submitted = ref(false);

const dataLocales = new DataLocale([
  {
    locale: "en",
    title: "Send Us <span class='text-success'>Message</span>",
    description:
      "Everything you need to know about creating, designing, and scanning QR Codes",
    title2:
      "Have Any Questions ? <br> <span class='down-mark-line text-success'>Let’s Start</span> to Talk",
    fullname: "Full name",
    number_phone: "Number Phone",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    send: "Send Message",
    thank: "Thank you for contacting us",
  },

  {
    locale: "vi",
    title: "Gửi <span class='text-success'>Tin nhắn</span> cho chúng tôi",
    description: "Mọi thứ bạn cần biết về việc tạo, thiết kế và quét mã QR",
    title2:
      "Có câu hỏi nào? <br> Hãy <span class='down-mark-line text-success'>Bắt đầu</span> trò chuyện với chúng tôi",
    fullname: "Họ và tên",
    number_phone: "Số điện thoại",
    phone: "Điện thoại",
    subject: "Chủ đề",
    message: "Tin nhắn",
    send: "Gửi tin nhắn",
    thank: "Cảm ơn bạn đã liên hệ với chúng tôi",
  },
  {
    locale: "fr",
    title: "Envoyez-nous un <span class='text-success'>message</span>",
    description:
      "Tout ce que vous devez savoir sur la création, la conception et la numérisation des codes QR",
    title2:
      "Avez-vous des questions ? <br> <span class='down-mark-line text-success'>Commençons</span> à discuter",
    fullname: "Nom complet",
    number_phone: "Numéro de téléphone",
    phone: "Téléphone",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer un message",
    thank: "Merci de nous avoir contactés",
  },
  {
    locale: "de",
    title: "Senden Sie uns eine <span class='text-success'>Nachricht</span>",
    description:
      "Alles, was Sie über die Erstellung, Gestaltung und das Scannen von QR-Codes wissen müssen",
    title2:
      "Haben Sie Fragen? <br> <span class='down-mark-line text-success'>Lassen Sie uns</span> sprechen",
    fullname: "Vollständiger Name",
    number_phone: "Telefonnummer",
    phone: "Telefon",
    subject: "Betreff",
    message: "Nachricht",
    send: "Nachricht senden",
    thank: "Vielen Dank für Ihre Kontaktaufnahme",
  },
  {
    locale: "es",
    title: "Envíanos un <span class='text-success'>mensaje</span>",
    description:
      "Todo lo que necesitas saber sobre la creación, diseño y escaneo de códigos QR",
    title2:
      "¿Tienes alguna pregunta? <br> <span class='down-mark-line text-success'>Empecemos</span> a hablar",
    fullname: "Nombre completo",
    number_phone: "Número de teléfono",
    phone: "Teléfono",
    subject: "Asunto",
    message: "Mensaje",
    send: "Enviar mensaje",
    thank: "Gracias por contactarnos",
  },
  {
    locale: "it",
    title: "Invia un <span class='text-success'>messaggio</span>",
    description:
      "Tutto ciò che devi sapere sulla creazione, progettazione e scansione di codici QR",
    title2:
      "Hai domande? <br> <span class='down-mark-line text-success'>Iniziamo</span> a parlare",
    fullname: "Nome completo",
    number_phone: "Numero di telefono",
    phone: "Telefono",
    subject: "Oggetto",
    message: "Messaggio",
    send: "Invia messaggio",
    thank: "Grazie per averci contattato",
  },
  {
    locale: "nl",
    title: "Stuur ons een <span class='text-success'>bericht</span>",
    description:
      "Alles wat u moet weten over het maken, ontwerpen en scannen van QR-codes",
    title2:
      "Heeft u vragen? <br> <span class='down-mark-line text-success'>Laten we</span> praten",
    fullname: "Volledige naam",
    number_phone: "Telefoonnummer",
    phone: "Telefoon",
    subject: "Onderwerp",
    message: "Bericht",
    send: "Stuur bericht",
    thank: "Bedankt voor uw bericht",
  },
  {
    locale: "zh",
    title: "发送 <span class='text-success'>留言</span>",
    description: "了解有关创建、设计和扫描 QR 码的一切",
    title2:
      "有问题吗？<br> <span class='down-mark-line text-success'>让我们开始</span> 聊天",
    fullname: "姓名",
    number_phone: "电话号码",
    phone: "电话",
    subject: "主题",
    message: "留言内容",
    send: "发送留言",
    thank: "感谢您与我们联系",
  },
  {
    locale: "ja",
    title: "<span class='text-success'>メッセージ</span>を送信する",
    description: "QRコードの作成、デザイン、スキャンに関するすべての情報",
    title2:
      "ご質問はありますか？<br> <span class='down-mark-line text-success'>さあ話しましょう</span>",
    fullname: "お名前",
    number_phone: "電話番号",
    phone: "電話",
    subject: "件名",
    message: "メッセージ",
    send: "メッセージを送信する",
    thank: "お問い合わせいただきありがとうございます",
  },
  {
    locale: "pt",
    title: "Envie-nos uma <span class='text-success'>mensagem</span>",
    description:
      "Tudo o que precisa de saber sobre criar, desenhar e ler códigos QR",
    title2:
      "Tem alguma questão? <br> <span class='down-mark-line text-success'>Vamos conversar</span>",
    fullname: "Nome completo",
    number_phone: "Número de telefone",
    phone: "Telefone",
    subject: "Assunto",
    message: "Mensagem",
    send: "Enviar mensagem",
    thank: "Obrigado por entrar em contato connosco",
  },
]);

const form = ref({
  email: "",
  phone: "",
  name: "",
  subject: "",
  message: "",
});
const loading = ref(false);
const submitContact = () => {
  loading.value = true;
  $fetch("/api/contact", {
    method: "POST",
    body: form.value,
  })
    .then((res) => {
      loading.value = false;
      notify({
        type: "success",
        text: "Thank you for getting in touch!",
      });
      submitted.value = true;
    })
    .catch((err) => {
      loading.value = false;
    });
};

const seoheader = new DataLocale([
  {
    locale: "en",
    title: "Contact Us - QR Gateway",
    description:
      "Get in touch with us for support, feedback, or suggestions. Our team is ready to assist you with any inquiries or issues you may have. Simply use our contact form to send us a message, and we'll get back to you as soon as possible. We value your feedback and strive to provide excellent customer service.",
  },
  {
    locale: "fr",
    title: "Contactez-nous - QR Gateway",
    description:
      "Contactez-nous pour obtenir du soutien, des commentaires ou des suggestions. Notre équipe est prête à vous aider pour toute demande d'information ou problème que vous pourriez rencontrer. Utilisez simplement notre formulaire de contact pour nous envoyer un message et nous vous répondrons dès que possible. Nous attachons de l'importance à vos commentaires et nous nous efforçons de fournir un excellent service client.",
  },
  {
    locale: "de",
    title: "Kontaktieren Sie uns - QR Gateway",
    description:
      "Kontaktieren Sie uns für Unterstützung, Feedback oder Vorschläge. Unser Team steht Ihnen bei allen Anfragen oder Problemen zur Verfügung. Verwenden Sie einfach unser Kontaktformular, um uns eine Nachricht zu senden, und wir werden uns so schnell wie möglich bei Ihnen melden. Wir schätzen Ihr Feedback und streben exzellenten Kundenservice an.",
  },
  {
    locale: "es",
    title: "Contáctenos - QR Gateway",
    description:
      "Póngase en contacto con nosotros para obtener soporte, comentarios o sugerencias. Nuestro equipo está listo para ayudarlo con cualquier consulta o problema que pueda tener. Simplemente utilice nuestro formulario de contacto para enviarnos un mensaje, y le responderemos lo antes posible. Valoramos sus comentarios y nos esforzamos por brindar un excelente servicio al cliente.",
  },
  {
    locale: "it",
    title: "Contattaci - QR Gateway",
    description:
      "Contattaci per supporto, feedback o suggerimenti. Il nostro team è pronto ad assisterti per qualsiasi richiesta o problema che potresti avere. Usa il nostro modulo di contatto per inviarci un messaggio e ti risponderemo al più presto. Valorizziamo il tuo feedback e ci impegniamo a fornire un eccellente servizio clienti.",
  },
  {
    locale: "nl",
    title: "Contact met ons opnemen - QR Gateway",
    description:
      "Neem contact met ons op voor ondersteuning, feedback of suggesties. Ons team staat klaar om u te helpen met vragen of problemen die u kunt hebben. Gebruik eenvoudig ons contactformulier om ons een bericht te sturen, en we zullen zo snel mogelijk terugkomen. We waarderen uw feedback en streven naar uitstekende klantenservice.",
  },
  {
    locale: "zh",
    title: "联系我们- QR Gateway",
    description:
      "如需支持、反馈或建议，请与我们联系。我们的团队随时准备好协助您处理任何疑问或问题。只需使用我们的联系表格向我们发送消息，我们将尽快回复您。我们重视您的反馈，并努力提供卓越的客户服务。",
  },
  {
    locale: "ja",
    title: "お問い合わせ - QR Gateway",
    description:
      "サポート、フィードバック、提案についてお問い合わせください。弊社のチームは、お客様がお持ちの問い合わせや問題についてお手伝いいたします。お問い合わせフォームからメッセージを送信するだけで、迅速に対応いたします。お客様のフィードバックを大切にし、優れたカスタマーサービスを提供することを目指しています。",
  },
  {
    locale: "vi",
    title: "Liên hệ - QR Gateway",
    description:
      "Liên hệ với chúng tôi để được hỗ trợ, gửi góp ý hoặc phản hồi. Đội ngũ của chúng tôi sẵn sàng hỗ trợ bạn với bất kỳ thắc mắc hoặc vấn đề nào mà bạn có. Chỉ cần sử dụng biểu mẫu liên hệ để gửi cho chúng tôi một tin nhắn và chúng tôi sẽ phản hồi bạn sớm nhất có thể. Chúng tôi đánh giá cao ý kiến đóng góp của bạn và luôn cố gắng cung cấp dịch vụ khách hàng tốt nhất.",
  },
  {
    locale: "pt",
    title: "Contate-nos - QR Gateway",
    description:
      "Entre em contato conosco para obter suporte, feedback ou sugestões. Nossa equipe está pronta para ajudá-lo com quaisquer dúvidas ou problemas que você possa ter. Basta usar nosso formulário de contato para nos enviar uma mensagem e entraremos em contato o mais breve possível. Valorizamos seus comentários e nos esforçamos para fornecer um excelente atendimento ao cliente.",
  },
]);

const datajd = useDataJd();
const meta = useMeta();

const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
const meta_tags = meta.metaTag({
  title: seoheader.data.title,
  description: seoheader.data.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/contact.jpg"),
});
useHead({
  title: seoheader.data.title,
  meta: [
    { name: "description", content: seoheader.data.description },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});
useSchemaOrg([
  defineWebPage({
    name: seoheader.data.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: seoheader.data.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/contact.jpg"),
    "@type": "ContactPage",
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      {
        item: {
          name: useI18n().t("contact"),
          "@id": datajd.currentHost() + "/contact",
        },
      },
    ],
  }),
]);
</script>
